import { Platform } from 'react-native';
import { Caption, Paragraph, Title } from 'react-native-paper';
import styled from 'styled-components/native';

export const H1 = styled(Title).attrs({
  dir: 'unset',
})`
  font-size: ${({ theme }) => theme.typography.heading[1].fontSize}px;
  line-height: ${({ theme }) => theme.typography.heading[1].lineHeight}px;
  ${Platform.OS === 'web' ? 'word-wrap: normal;' : ''}
`;

export const H2 = styled(Title).attrs({
  dir: 'unset',
})`
  font-size: ${({ theme }) => theme.typography.heading[2].fontSize}px;
  line-height: ${({ theme }) => theme.typography.heading[2].lineHeight}px;
  ${Platform.OS === 'web' ? 'word-wrap: normal;' : ''}
`;

export const H3 = styled(Title).attrs({
  dir: 'unset',
})`
  font-size: ${({ theme }) => theme.typography.heading[3].fontSize}px;
  line-height: ${({ theme }) => theme.typography.heading[3].lineHeight}px;
  ${Platform.OS === 'web' ? 'word-wrap: normal;' : ''}
`;
export const Body3 = styled(Title).attrs({
  dir: 'unset',
})`
  font-size: ${({ theme }) => theme.typography.body[3].fontSize}px;
  line-height: ${({ theme }) => theme.typography.body[3].lineHeight}px;
  ${Platform.OS === 'web' ? 'word-wrap: normal;' : ''}
`;
export const Subtitle1 = styled(Caption).attrs({
  dir: 'unset',
})`
  font-size: ${({ theme }) => theme.typography.subtitle[1].fontSize}px;
  line-height: ${({ theme }) => theme.typography.subtitle[1].lineHeight}px;
  ${Platform.OS === 'web' ? 'word-wrap: normal;' : ''}
`;

export const Subtitle2 = styled(Caption).attrs({
  dir: 'unset',
})`
  font-size: ${({ theme }) => theme.typography.subtitle[2].fontSize}px;
  line-height: ${({ theme }) => theme.typography.subtitle[2].lineHeight}px;
  ${Platform.OS === 'web' ? 'word-wrap: normal;' : ''}
`;

export const Body1 = styled(Paragraph).attrs({
  dir: 'unset',
  numberOfLines: 1,
  ellipsizeMode: 'tail',
})`
  font-size: ${({ theme }) => theme.typography.body[1].fontSize}px;
  line-height: ${({ theme }) => theme.typography.body[1].lineHeight}px;
  ${Platform.OS === 'web' ? 'word-wrap: normal;' : ''}
`;

export const Body4 = styled(Paragraph).attrs({
  numberOfLines: 3,
})`
  font-size: ${({ theme }) => theme.typography.body[1].fontSize}px;
  line-height: ${({ theme }) => theme.typography.body[1].lineHeight}px;
  margin-right: 20px;
  ${Platform.OS === 'web' ? 'word-wrap: normal;' : ''}
`;

export const Body2 = styled(Paragraph).attrs({
  dir: 'unset',
})`
  font-size: ${({ theme }) => theme.typography.body[2].fontSize}px;
  line-height: ${({ theme }) => theme.typography.body[2].lineHeight}px;
  ${Platform.OS === 'web' ? 'word-wrap: normal;' : ''}
`;
